import { Number } from "components/common"
import { t } from "i18next"
import store from "store"
import { convertToSpecificAreaUnit, getAreaUnit, localisedValue } from "utils"

const agency = store.getState().app?.user?.info?.AgencyConfiguration?.Platform?.platformKey

const lmsProjectTransformer = obj => {
  const data = { ...obj }
  const lmsProjectData = [
    { label: t("location"), data: localisedValue({ object: data?.Location, key: "name" }) },
    { label: t("City"), data: localisedValue({ object: data, key: "projectCity" }) },
    { label: t("Country"), data: localisedValue({ object: data?.Address?.Country, key: "name" }) },
    {
      label: t("Unit Types"),
      data: data?.UnitTypes?.map(item => ({
        taglabel: localisedValue({ object: item, key: "name" }),
      })),
    },
    { label: t("Available Units"), data: data?.listingStats?.totalAvailableUnits },
    {
      label: t("Price Range"),
      data: {
        minPrice: data?.priceRange?.minPrice,
        maxPrice: data?.priceRange?.maxPrice,
      },
      type: "numberComponent",
      isComponent: true,
      columnView: true,
    },
    {
      label: t("Area Range"),
      data: {
        maxArea: `${convertToSpecificAreaUnit(
          data?.areaRange?.maxArea,
          agency === "bayut_ksa" ? "sq_m" : "sq_f"
        )?.toFixed(2)} ${getAreaUnit(agency)}`,
        minArea: `${convertToSpecificAreaUnit(
          data?.areaRange?.minArea,
          agency === "bayut_ksa" ? "sq_m" : "sq_f"
        )?.toFixed(2)} ${getAreaUnit(agency)}`,
      },
      isComponent: true,
      type: "areaComponent",
    }, // add area unit for this
  ]

  const bookingInformationData = [
    {
      label: t("Token Amount"),
      data: {
        value: data?.minToken,
        type: data?.minTokenUnit,
      },
      type: "numberComponent",
      isComponent: true,
      columnView: true,
    },
    {
      label: t("Partial Down Payment(PDP)"),
      data: { value: data?.partialDp },
      type: "wrapNumberComponent",
      isComponent: true,
      columnView: true,
    },
    {
      label: t("Complete Down Payment"),
      data: { value: data?.ProjectFinancial?.completeDownPayment },
      type: "wrapNumberComponent",
      isComponent: true,
      columnView: true,
    },
    {
      label: t("Possession Charges"),
      data: { value: data?.Possessions[0] },
      type: "wrapNumberComponent",
      isComponent: true,
      columnView: true,
    },
    { label: t("Installment Duration"), data: data?.Instalments[0]?.instalment },
  ]

  return { lmsProjectData, bookingInformationData }
}

export default lmsProjectTransformer
